// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/**\n * Creative Preview iframe styles\n */\n\n.creative-preview-frame iframe {\n\tborder:none;\n}", "",{"version":3,"sources":["CreativePreview.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC,WAAW;AACZ","file":"CreativePreview.css","sourcesContent":["/**\n * Creative Preview iframe styles\n */\n\n.creative-preview-frame iframe {\n\tborder:none;\n}"]}]);
// Exports
module.exports = exports;
